// src/services/trafficService.js
// Records page-view events to the auth backend for super-admin traffic analytics.

import { API_BASE_URL } from './config';

// Stable session ID for this browser tab (regenerated on hard refresh)
const SESSION_ID = `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 7)}`;

const TRAFFIC_URL = `${API_BASE_URL}/traffic`;

const getHeaders = () => ({
  'Content-Type': 'application/json',
  Authorization: `Bearer ${localStorage.getItem('authToken') || ''}`,
});

/**
 * Fire-and-forget: record that the authenticated user navigated to `view`.
 * Silently ignored if the user is not logged in or the backend is unreachable.
 */
export const trackPageView = (view) => {
  const token = localStorage.getItem('authToken');
  if (!token || !view) return;

  fetch(TRAFFIC_URL, {
    method: 'POST',
    headers: getHeaders(),
    body: JSON.stringify({ view, sessionId: SESSION_ID }),
  }).catch(() => { /* network error — ignore silently */ });
};

/**
 * Fetch aggregated traffic stats for the super-admin panel.
 * Throws on both network errors and non-2xx responses so the caller can show an error state.
 */
export const fetchTrafficStats = async () => {
  const res = await fetch(`${TRAFFIC_URL}/stats`, { headers: getHeaders() });
  const json = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(json.message || `HTTP ${res.status}`);
  return json.data;
};
